import { configureStore } from '@reduxjs/toolkit';
import { cartReducer } from './reducers/cartSlice';
import { isOpenReducer } from './reducers/isOpenSlice';
import { shoppingCardReducer } from './reducers/shoppingCardSlice';
import { sidebarReducer } from './reducers/sidebarSlice';
import { authReducer } from './reducers/userSlice';

export const store = configureStore({
	reducer: {
		shoppingCard: shoppingCardReducer,
		sidebar: sidebarReducer,
		cart: cartReducer,
		isOpen: isOpenReducer,
		user: authReducer,
	},
	devTools: process.env.NODE_ENV !== 'production',
});
